import { Component, OnInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { CSForm } from 'src/app/shared/models/cs-form.model';
import { CSFormService } from 'src/app/shared/services/cs-form.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { FormTransactionService } from 'src/app/shared/services/form-transaction.service';
import { AuthService } from '../account/auth.service';
import { fileUploadService } from 'src/app/shared/services/fileUpload.service';
import { FormMember } from './form-member.model';
import { User } from '../account/user.model';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { LinkHandlerService } from 'src/app/shared/services/link-handler.service';
import { FormDesign, formDesign, fieldText, answerText, missingFields } from 'src/app/shared/forms/form-design';
import { FormCheckoutService, FormOrderView } from 'src/app/shared/forms/form-checkout.service';
import { resourceText } from 'src/app/shared/services/localization';
declare var $: any;
@Component({ selector: 'app-form-transaction', templateUrl: './form-transaction.component.html', styleUrls: ['./form-transaction.component.scss', '../../shared/forms/forms.scss', '../../shared/forms/form-flow-layout.scss'], standalone: false })
export class FormTransactionComponent implements OnInit {
    csForm: CSForm;
    formId: number;
    User: User;
    userId = '';
    user = '';
    role = 0;
    isLoading = true;
    saving = false;
    error = '';
    formNotFound = false;
    formExpired = false;
    pictureUrl = '';
    previewItem: { name: string; imageUrl?: string } = null;
    previewImageFailed = false;
    members: FormMember[] = [];
    currentMember: FormMember;
    design: FormDesign;
    step = 0;
    quote: any;
    receiptEmail = '';
    quantities: {
        [id: string]: number;
    } = {};
    userAmount: number;
    reviewAnswers: any[] = [];
    order: FormOrderView;
    intent: any;
    private baseFields: any[] = [];
    private pageRenders: any[] = [];
    private fileInputs = new Map<string, File[]>();
    private drafts = new Map<number, {
        fields: any[];
        files: Map<string, File[]>;
        quantities: any;
        amount: number;
        email: string;
    }>();
    private uploaded = new WeakMap<File, {
        name: string;
        url: string;
    }>();
    fieldText = fieldText;
    answerText = answerText;
    constructor(private route: ActivatedRoute, private formService: CSFormService, private formTransactionService: FormTransactionService, public globalService: GlobalService, private location: Location, private authService: AuthService, private uploads: fileUploadService, private identity: IdentityService, private router: Router, private links: LinkHandlerService, private checkout: FormCheckoutService, private cdr: ChangeDetectorRef, private element: ElementRef) { }
    openItemPhoto(item: { name: string; imageUrl?: string }, dialog: HTMLDialogElement) {
        if (!item.imageUrl) return;
        this.previewItem = item;
        this.previewImageFailed = false;
        dialog.showModal();
    }
    async ngOnInit() {
        this.isLoading = true;
        this.error = '';
        try {
            this.User = await this.authService.autoLogin(0);
            this.userId = this.User?.id || '';
            this.user = this.globalService.currentUser || '';
            this.role = this.identity.hasFormAdmin() ? 1 : this.identity.hasFormEditor() ? 2 : this.identity.hasFormsView() ? 3 : 0;
            this.formId = Number(this.route.snapshot.params.formId);
            this.csForm = await this.formService.getForm(this.formId);
            if (!this.csForm?.id || this.csForm.deleted) {
                this.formNotFound = true;
                return;
            }
            if (this.csForm.formExpires && new Date(this.csForm.validThru) < new Date()) {
                this.formExpired = true;
                return;
            }
            if (this.csForm.requireLogin && this.csForm.action !== 6 && !this.User) {
                this.router.navigate([this.globalService.subdomain + '/login']);
                return;
            }
            this.globalService.title.push(this.globalService.screenHeader);
            this.globalService.screenHeader = this.csForm.name;
            this.baseFields = JSON.parse(this.csForm.formData || '[]').filter(f => !f.access || f.role?.includes(String(this.role)));
            this.design = formDesign(this.csForm.designJson, JSON.parse(this.csForm.formData || '[]'));
            this.pictureUrl = this.csForm.pictureUrl || '';
            if (this.User && this.csForm.memberSelection && this.csForm.action !== 6)
                this.members = await this.formService.getFormMembers(this.userId, this.formId) || [];
            if (this.csForm.memberSelection && this.csForm.requireLogin && this.csForm.action !== 6 && !this.members.length)
                throw Error('FORM_NO_MEMBERS');
            this.userAmount = this.design.payment.suggested ?? this.design.payment.minimum;
            this.receiptEmail = this.User?.['email'] || '';
            this.intent = this.checkout.intent(this.globalService.subdomain, this.formId);
            if (this.intent.orderId) {
                this.router.navigate([this.globalService.subdomain + '/form-order/' + this.intent.orderId]);
                return;
            }
            this.changingMember(0);
        }
        catch (e) {
            this.error = resourceText(e?.message === 'FORM_NO_MEMBERS' ? 'FORM_NO_MEMBERS' : 'FORM_LOAD_FAILED');
        }
        finally {
            this.isLoading = false;
            this.cdr.markForCheck();
        }
    }
    get questionCount() { return this.design?.pages.length || 0; }
    get paymentStep() { return this.questionCount; }
    get reviewStep() { return this.questionCount + (this.csForm?.paymentsEnabled ? 1 : 0); }
    get stepCount() { return this.reviewStep + 1; }
    get total() { if (!this.csForm?.paymentsEnabled)
        return 0; const p = this.design.payment; return p.mode === 'fixed' ? this.csForm.paymentAmount || 0 : p.mode === 'custom' ? Number(this.userAmount) || 0 : p.items.reduce((n, item) => n + (this.quantities[item.id] || 0) * item.unitPrice, 0); }
    private answers() { return this.pageRenders.reduce((all, renderer) => all.concat(renderer.userData || []), []).map(f => ({ ...f, ...(f.type === 'file' && this.fileInputs.get(f.name)?.length ? { data: this.fileInputs.get(f.name).map(file => this.uploaded.get(file) || { name: file.name, url: '' }) } : {}) })); }
    changingMember(index: number) {
        if (this.pageRenders.length)
            this.drafts.set(this.currentMember?.id || 0, { fields: this.answers(), files: new Map(this.fileInputs), quantities: { ...this.quantities }, amount: this.userAmount, email: this.receiptEmail });
        this.currentMember = this.members[index];
        const saved = this.drafts.get(this.currentMember?.id || 0);
        let fields = JSON.parse(JSON.stringify(saved?.fields || this.baseFields));
        this.fileInputs = new Map(saved?.files || []);
        this.quantities = { ...this.design.payment.items.reduce((values, item) => { values[item.id] = 0; return values; }, {} as { [id: string]: number }), ...saved?.quantities };
        this.userAmount = saved?.amount ?? this.design.payment.suggested ?? this.design.payment.minimum;
        this.receiptEmail = saved?.email ?? this.currentMember?.emailAddress ?? this.User?.['email'] ?? '';
        if (!saved) {
            const m = this.currentMember;
            const basic = { bi_first_name: m?.firstName, bi_last_name: m?.lastName, bi_full_name: m ? m.firstName + ' ' + m.lastName : '', bi_email: m?.emailAddress, bi_street: m?.street, bi_city: m?.city, bi_state: m?.state, bi_zip: m?.zip, bi_cell_phone: m?.phoneNumber, bi_marital: m?.maritalStatus, bi_gender: m?.gender == null ? '' : m.gender ? '1' : '0', bi_dob: m?.dateOfBirth ? String(m.dateOfBirth).slice(0, 10) : '' };
            if (m)
                for (const f of fields)
                    if (Object.prototype.hasOwnProperty.call(basic, f.name)) {
                        f.userData = [String(basic[f.name] ?? '')];
                        f.values?.forEach(v => v.selected = String(v.value) === f.userData[0]);
                    }
        }
        const root: HTMLElement = this.element.nativeElement.querySelector('.fb-render');
        root.replaceChildren();
        this.pageRenders = [];
        this.design.pages.forEach((page, index) => {
            const host = document.createElement('div');
            host.dataset.formPage = String(index);
            root.appendChild(host);
            const pageFields = fields.filter(f => page.fields.includes(f.name) || index === 0 && !f.name);
            const renderer = $(host).formRender({ dataType: 'json', formData: pageFields, roles: { 1: 'Form Admin', 2: 'Form Editor', 3: 'Form Viewer' } });
            this.pageRenders.push(renderer);
            host.querySelectorAll<HTMLInputElement>('input[type=file]').forEach(input => input.addEventListener('change', () => { this.fileInputs.set(input.name, Array.from(input.files)); }));
        });
        this.step = 0;
        this.quote = null;
        this.showPage();
    }
    private showPage() { this.element.nativeElement.querySelectorAll('[data-form-page]').forEach((el: HTMLElement) => el.hidden = Number(el.dataset.formPage) !== this.step); }
    private validPage(index: number) {
        const fields = this.pageRenders[index]?.userData || [];
        const missing = missingFields(fields, this.fileInputs);
        if (missing.length) {
            this.error = resourceText('FORM_REQUIRED_ANSWERS') + ' ' + missing.map(f => fieldText(f.label || f.name)).join(', ');
            return false;
        }
        const host = this.element.nativeElement.querySelector(`[data-form-page="${index}"]`);
        const invalid = Array.from(host?.querySelectorAll('input:not([type=file]),select,textarea') || []).find((el: HTMLInputElement) => !el.checkValidity()) as HTMLInputElement;
        if (invalid) {
            invalid.reportValidity();
            return false;
        }
        return true;
    }
    async next() {
        if (this.saving)
            return;
        this.error = '';
        if (this.step < this.questionCount && !this.validPage(this.step))
            return;
        if (this.step + 1 === this.reviewStep) {
            await this.review();
            return;
        }
        this.step++;
        this.showPage();
    }
    back() { if (this.saving)
        return; this.error = ''; this.step = Math.max(0, this.step - 1); this.showPage(); }
    editPage(index: number) { if (this.saving || this.order)
        return; this.step = index; this.showPage(); }
    request() { return { formId: this.formId, memberId: this.currentMember?.id || 0, formData: JSON.stringify(this.answers()), quantities: this.quantities, userAmount: this.userAmount, receiptEmail: this.receiptEmail }; }
    async review() { this.saving = true; try {
        this.quote = await this.checkout.quote(this.request());
        this.reviewAnswers = this.answers();
        this.step = this.reviewStep;
        this.showPage();
    }
    catch (e) {
        this.error = resourceText(e?.error?.code || 'FORM_REVIEW_FAILED');
    }
    finally {
        this.saving = false;
        this.cdr.markForCheck();
    } }
    async submit() {
        if (this.saving || this.order || this.step !== this.reviewStep || !this.quote)
            return;
        this.saving = true;
        this.error = '';
        try {
            const root: HTMLElement = this.element.nativeElement.querySelector('.fb-render');
            root.querySelectorAll<HTMLInputElement>('input[type=file]').forEach(input => { if (input.files?.length)
                this.fileInputs.set(input.name, Array.from(input.files)); });
            for (const files of this.fileInputs.values())
                for (const file of files)
                    if (!this.uploaded.has(file)) {
                        const url = await this.uploads.uploadFile(file, file.name, 'attachments');
                        if (!url)
                            throw Error('FORM_UPLOAD_FAILED');
                        this.uploaded.set(file, { name: file.name, url });
                    }
            this.order = await this.checkout.submit({ ...this.request(), quoteHash: this.quote.hash, ...this.intent });
            this.checkout.remember(this.globalService.subdomain, this.formId, this.intent, this.order);
            if (this.order.status === 'submitted' && this.csForm.submitUrl?.trim())
                this.links.open(this.csForm.submitUrl.trim());
        }
        catch (e) {
            const code = e?.error?.code || 'FORM_SUBMIT_FAILED';
            this.error = resourceText(code);
            if (code === 'FORM_CHANGED_REVIEW')
                this.quote = null;
        }
        finally {
            this.saving = false;
            this.cdr.markForCheck();
        }
    }
    quantity(id: string, delta: number, max: number) { this.quantities[id] = Math.min(max, Math.max(0, Math.trunc(Number(this.quantities[id]) || 0) + delta)); }
    filesFor(field: any) { return this.fileInputs.get(field.name)?.map(f => f.name).join(', ') || answerText(field); }
}
